<template>
  <div class="card mb-5 mb-xxl-8">
    <div class="card mb-5 mb-xl-10" id="kt_profile_details_view">
      <div class="card-header flex-wrap border-0 pt-6 pb-0">
        <div class="card-title">
          <h3 class="card-label"> {{ $t('shop.product_outofstock_list') }} </h3>
        </div>
      </div>

      <div class="card-body">
        <!-- Onglets de filtre -->
        <div class="d-flex gap-2 mb-4 flex-wrap">
          <button class="filter-tab" :class="{ active: activeFilter === null }" @click="setFilter(null)">
            Tous <span class="filter-count">{{ counts.total ?? 0 }}</span>
          </button>
          <button class="filter-tab" :class="{ active: activeFilter === 'rupture' }" @click="setFilter('rupture')">
            <span class="dot dot-danger"></span> Rupture <span class="filter-count">{{ counts.rupture ?? 0 }}</span>
          </button>
          <button class="filter-tab" :class="{ active: activeFilter === 'critique' }" @click="setFilter('critique')">
            <span class="dot dot-warning"></span> Critique <span class="filter-count">{{ counts.critique ?? 0 }}</span>
          </button>
          <button class="filter-tab" :class="{ active: activeFilter === 'alerte' }" @click="setFilter('alerte')">
            <span class="dot dot-info"></span> Alerte <span class="filter-count">{{ counts.alerte ?? 0 }}</span>
          </button>
        </div>

        <!-- Barre d'action flottante quand des produits sont sélectionnés -->
        <div v-if="selectedProducts.length > 0" class="d-flex align-items-center gap-3 mb-3 p-3 bg-light-primary rounded border border-primary">
          <span class="fw-bold text-primary">{{ selectedProducts.length }} produit(s) sélectionné(s)</span>
          <button class="btn btn-sm btn-primary" @click="openSupplyModal">
            <i class="fa fa-boxes me-1"></i> Approvisionner
          </button>
          <button class="btn btn-sm btn-light" @click="clearSelection">Tout désélectionner</button>
        </div>

        <div class="row">
          <table class="table align-middle table-row-bordered fs-6 gy-3" id="kt_datatable_shop_products_out">
            <thead>
              <tr class="text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0">
                <th class="w-30px"><input type="checkbox" id="chk_select_all" class="form-check-input" /></th>
                <th class="min-w-150px">{{ $t('product.name') }}</th>
                <th class="min-w-80px">{{ $t('product.stock') }}</th>
                <th class="min-w-80px">{{ $t('product.stock_security') }}</th>
                <th class="min-w-80px">{{ $t('product.stock_alert') }}</th>
                <th class="min-w-100px">Statut</th>
                <th class="min-w-80px">{{ $t('action') }}</th>
              </tr>
            </thead>
          </table>
        </div>
      </div>

      <update-shop-product
        :form="formProductEditData"
        :get-taxes="getTaxes"
        @success="loadShopProduct"
      ></update-shop-product>
    </div>

    <!-- Modal approvisionnement -->
    <div class="modal bg-white fade" tabindex="-1" id="supplyModal">
      <div class="modal-dialog modal-fullscreen">
        <form @submit.prevent="submitSupply" class="modal-content shadow-none">
          <div class="modal-header">
            <div class="row modal-title w-100">
              <h5 class="mt-2">Approvisionnement — {{ supplyForm.numero }}</h5>
            </div>
            <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal">
              <span class="svg-icon svg-icon-2x">✕</span>
            </div>
          </div>

          <div class="modal-body">
            <div class="card">
              <div class="card-body">
                <!-- Date -->
                <div class="row mb-4">
                  <div class="col-md-3">
                    <label class="required form-label">Date</label>
                    <input class="form-control kt_supply_date" v-model="supplyForm.date" required />
                  </div>
                </div>

                <!-- Lignes produits -->
                <div class="row bg-light rounded py-4 my-2" v-for="(item, index) in supplyForm.products" :key="index">
                  <div class="col">
                    <div class="row">
                      <div class="col-md-3 my-2">
                        <label class="form-label fw-bold">{{ item.name }}</label>
                        <div class="text-muted fs-8">Stock actuel : <span :class="item.status === 'rupture' ? 'text-danger' : item.status === 'critique' ? 'text-warning' : 'text-info'">{{ item.stock_variable }}</span></div>
                      </div>
                      <div class="col-md-2 my-2">
                        <label class="required form-label">Quantité à entrer</label>
                        <input required type="number" min="1" v-model="item.quantity" class="form-control h-50px" />
                      </div>
                      <div class="col-md-2 my-2">
                        <label class="form-label">Prix achat</label>
                        <input type="number" min="0" v-model="item.buyPrice" class="form-control h-50px" />
                      </div>
                      <div class="col-md-2 my-2">
                        <label class="required form-label">Prix vente HT</label>
                        <input required type="number" min="0" v-model="item.sellPrice" class="form-control h-50px" />
                      </div>
                      <div class="col-md-2 my-2">
                        <label class="form-label">Stock sécurité</label>
                        <input type="number" min="0" v-model="item.stock_security" class="form-control h-50px" />
                      </div>
                      <div class="col-md-1 my-2">
                        <label class="form-label">Alerte</label>
                        <input type="number" min="0" v-model="item.stock_alert" class="form-control h-50px" />
                      </div>
                    </div>
                  </div>
                  <div class="col-auto d-flex align-items-center">
                    <button v-if="supplyForm.products.length > 1" @click.prevent="supplyForm.products.splice(index, 1)" type="button" class="btn btn-sm btn-icon text-danger">
                      <i class="fa fa-trash"></i>
                    </button>
                  </div>
                </div>

              </div>
            </div>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-light btn-light-close" data-bs-dismiss="modal">{{ $t('button.close') }}</button>
            <button type="submit" id="kt_submit_supply" class="btn btn-primary fw-bolder">
              <span class="indicator-label"><i class="fa fa-boxes me-1"></i> Valider l'entrée</span>
              <span class="indicator-progress">{{ $t('loading') }} <span class="spinner-border spinner-border-sm align-middle ms-2"></span></span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { BASE_URL } from '@/services/api'
import UpdateShopProduct from '@/components/shop/UpdateShopProduct'

const STATUS_CONFIG = {
  rupture:  { label: 'Rupture',  badge: 'badge-danger',  row: 'table-danger'  },
  critique: { label: 'Critique', badge: 'badge-warning', row: 'table-warning' },
  alerte:   { label: 'Alerte',   badge: 'badge-info',    row: 'table-info'    },
}

export default {
  name: 'ProductsEnded',
  components: { UpdateShopProduct },
  props: {
    shop:       { type: Object,  default: () => ({}) },
    entryCount: { type: Number,  default: 0 },
  },
  data() {
    return {
      activeFilter: null,
      counts: { total: 0, rupture: 0, critique: 0, alerte: 0 },
      table: null,
      selectedProducts: [],
      supplyForm: {
        shop_id: this.$route.params.id,
        numero: '',
        date: this._today(),
        status: 'Draft',
        products: [],
      },
      formProductEditData: {
        id: null, name: '', price: 0,
        stock_security: 0, stock_alert: 0,
        row: null, product_shop_taxes: [],
      },
      formProductDeleteData: { id: null, row: null },
      isLoading: false,
      localShop: {},
    }
  },
  computed: {
    ...mapGetters('taxes', ['getTaxes']),
    shopPrefix() {
      const s = this.shop?.name ? this.shop : this.localShop
      return s.prefix
        ? this.$addYearToPrefixe(s.prefix)
        : 'ENT/' + (s.name ?? 'BOU').slice(0, 3).toUpperCase() + '/' + new Date().getFullYear()
    },
  },
  watch: {
    '$i18n.locale'(value) {
      if (value && this.table) this.$nextTick(() => this.fetchDatas())
    },
    '$route.params.id'(newId, oldId) {
      // Vue Router réutilise ce composant quand on passe de la fiche d'une
      // boutique à une autre (même route, seul :id change) — sans ce watcher,
      // la liste reste celle de l'ancienne boutique consultée.
      if (newId && newId !== oldId) this.initForShop()
    },
  },
  async mounted() {
    await this.initForShop()

    $(document).on('change', '#chk_select_all', (e) => {
      const checked = e.target.checked
      $('#kt_datatable_shop_products_out tbody .chk_row').each((_, el) => {
        el.checked = checked
        this._toggleProduct(el, checked)
      })
    })

    $(document).on('change', '#kt_datatable_shop_products_out .chk_row', (e) => {
      this._toggleProduct(e.target, e.target.checked)
      const total = $('#kt_datatable_shop_products_out tbody .chk_row').length
      const checked = $('#kt_datatable_shop_products_out tbody .chk_row:checked').length
      $('#chk_select_all').prop('indeterminate', checked > 0 && checked < total)
      $('#chk_select_all').prop('checked', checked === total)
    })

    $(document).on('click', '#kt_datatable_shop_products_out .edit_btn', (e) => {
      const t = e.target.closest('.edit_btn')
      this.formProductEditData.id             = t.getAttribute('data-id')
      this.formProductEditData.name           = t.getAttribute('data-name')
      this.formProductEditData.price          = t.getAttribute('data-price')
      this.formProductEditData.stock_security = t.getAttribute('data-stock-security')
      this.formProductEditData.stock_alert    = t.getAttribute('data-stock-alert')
      this.formProductEditData.row            = t.getAttribute('data-row')
      this.formProductEditData.product_shop_taxes = t.getAttribute('data-taxes')
        ? t.getAttribute('data-taxes').split(',') : []
      $('#updateShopProductModal').modal('toggle')
    })
  },
  methods: {
    ...mapActions('shop', ['showShop', 'removeProductFromShop', 'addProductsToShop']),
    ...mapActions('taxes', ['loadTaxes']),

    async initForShop() {
      this.fetchDatas()
      this.loadCounts()
      await this.loadTaxes()
      const res = await this.showShop(this.$route.params.id)
      this.localShop = res.data.shop
    },

    _today() {
      const d = new Date()
      const pad = n => String(n).padStart(2, '0')
      return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()}`
    },

    _toggleProduct(el, checked) {
      const id     = el.getAttribute('data-id')
      const exists = this.selectedProducts.findIndex(p => p.id === id)
      if (checked && exists === -1) {
        this.selectedProducts.push({
          id,
          name:           el.getAttribute('data-name'),
          stock_variable: Number(el.getAttribute('data-stock')),
          stock_security: Number(el.getAttribute('data-security')),
          stock_alert:    Number(el.getAttribute('data-alert')),
          status:         el.getAttribute('data-status'),
          price:          Number(el.getAttribute('data-price')),
          taxe_id:        el.getAttribute('data-taxes') ? el.getAttribute('data-taxes').split(',') : [],
        })
      } else if (!checked && exists !== -1) {
        this.selectedProducts.splice(exists, 1)
      }
    },

    clearSelection() {
      this.selectedProducts = []
      $('#kt_datatable_shop_products_out .chk_row').prop('checked', false)
      $('#chk_select_all').prop('checked', false).prop('indeterminate', false)
    },

    openSupplyModal() {
      this.supplyForm.numero   = this.shopPrefix + '/' + this.$incrementValue(this.entryCount)
      this.supplyForm.date     = this._today()
      this.supplyForm.shop_id  = this.$route.params.id
      this.supplyForm.products = this.selectedProducts.map(p => ({
        id:             p.id,
        name:           p.name,
        stock_variable: p.stock_variable,
        status:         p.status,
        quantity:       1,
        buyPrice:       p.price ?? 0,
        sellPrice:      p.price ?? 0,
        taxes:          p.taxe_id ?? [],
        stock_security: p.stock_security ?? 0,
        stock_alert:    p.stock_alert ?? 0,
        product_lot_id: null,
      }))
      $('#supplyModal').modal('show')
      this.$nextTick(() => {
        $('.kt_supply_date').flatpickr({ dateFormat: 'd/m/Y' })
      })
    },

    async submitSupply() {
      this.$loading('kt_submit_supply')
      try {
        await this.addProductsToShop(this.supplyForm)
        window.toastr['success'](i18n.global.t('notification.store.entrie_create'))
        $('#supplyModal').modal('hide')
        this.clearSelection()
        this.table?.ajax.reload()
        this.loadCounts()
        this.$emit('reloadEditData')
      } catch (err) {
        // handled by interceptor
      } finally {
        this.$stopLoading('kt_submit_supply')
      }
    },

    async loadCounts() {
      try {
        const AUTH_TOKEN = Ls.get('auth.token')
        const res = await window.axios.get(
          BASE_URL + '/get/shop/' + this.$route.params.id + '/products/outOfStock/counts',
          { headers: { Authorization: 'Bearer ' + AUTH_TOKEN } }
        )
        this.counts = res.data
      } catch (e) {}
    },

    setFilter(filter) {
      this.activeFilter = filter
      this.clearSelection()
      if (this.table) { this.table.destroy(); this.table = null }
      this.fetchDatas()
    },

    fetchDatas() {
      const AUTH_TOKEN   = Ls.get('auth.token')
      const activeFilter = this.activeFilter

      this.table = $('#kt_datatable_shop_products_out').DataTable({
        destroy: true,
        responsive: true,
        searchDelay: 500,
        processing: true,
        serverSide: true,
        pageLength: Ls.get('pageLength') ?? 25,
        lengthMenu: [10, 25, 50, 100],
        order: [[1, 'asc']],
        ajax: {
          url: BASE_URL + '/get/shop/' + this.$route.params.id + '/products/outOfStock/datatables',
          type: 'GET',
          beforeSend(request) {
            request.setRequestHeader('Authorization', 'Bearer ' + AUTH_TOKEN)
          },
          data(d) {
            if (activeFilter) d.filter = activeFilter
          },
        },
        columns: [
          { data: null, orderable: false },
          { data: 'name' },
          { data: 'stock_variable' },
          { data: 'stock_security' },
          { data: 'stock_alert' },
          { data: 'status' },
          { data: 'Actions', responsivePriority: -1 },
        ],
        columnDefs: [
          {
            targets: 0,
            className: 'dt-center',
            render: (t, a, e) =>
              `<input type="checkbox" class="form-check-input chk_row"
                data-id="${e.id}"
                data-name="${(e.name ?? '').replace(/"/g, '&quot;')}"
                data-stock="${e.stock_variable}"
                data-security="${e.stock_security}"
                data-alert="${e.stock_alert}"
                data-status="${e.status}"
                data-price="${e.price ?? 0}"
                data-taxes="${(e.taxe_id ?? []).join(',')}" />`,
          },
          {
            targets: 1,
            className: 'dt-center',
            render: (t, a, e) => `<span data-id="${e.id}">${t}</span>`,
          },
          {
            targets: 2,
            className: 'dt-center fw-bold',
            render: (t, a, e) => {
              const cls = e.status === 'rupture' ? 'text-danger' : e.status === 'critique' ? 'text-warning' : 'text-info'
              return `<span class="${cls}">${t}</span>`
            },
          },
          { targets: 3, className: 'dt-center', render: t => t },
          { targets: 4, className: 'dt-center', render: t => t },
          {
            targets: 5,
            className: 'dt-center',
            orderable: false,
            render: (t) => {
              const cfg = STATUS_CONFIG[t] ?? { label: t, badge: 'badge-secondary' }
              return `<span class="badge ${cfg.badge}">${cfg.label}</span>`
            },
          },
          {
            targets: 6,
            className: 'dt-center',
            orderable: false,
            render: (t, a, e, l) => {
              if (this.localShop?.archive) return ''
              return `<button type="button"
                class="btn btn-icon btn-active-light-warning w-30px h-30px edit_btn"
                title="Modifier les seuils"
                data-row="${l.row}"
                data-id="${e.id}"
                data-name="${(e.name ?? '').replace(/"/g, '&quot;')}"
                data-price="${e.price}"
                data-stock-security="${e.stock_security}"
                data-stock-alert="${e.stock_alert}"
                data-taxes="${(e.taxe_id ?? []).join(',')}">
                <i class="fa fa-sliders-h"></i>
              </button>`
            },
          },
        ],
        createdRow(row, data) {
          const cfg = STATUS_CONFIG[data.status]
          if (cfg) $(row).addClass(cfg.row)
        },
        language: {
          url: this.$i18n?.locale === 'fr'
            ? '//cdn.datatables.net/plug-ins/1.10.20/i18n/French.json'
            : '//cdn.datatables.net/plug-ins/1.10.20/i18n/English.json',
        },
      })
    },

    loadShopProduct() {
      this.table?.ajax.reload()
      this.loadCounts()
    },
  },
}
</script>

<style scoped>
:deep(.table-danger td)  { background-color: rgba(220, 53, 69, 0.08)  !important; }
:deep(.table-warning td) { background-color: rgba(255, 193, 7, 0.08)   !important; }
:deep(.table-info td)    { background-color: rgba(13, 202, 240, 0.08)  !important; }

.filter-tab {
  background: #f5f5f7;
  border: 1px solid #e4e6ef;
  border-radius: 6px;
  padding: 6px 14px;
  font-size: 0.85rem;
  color: #6c757d;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  transition: background 0.15s, color 0.15s, border-color 0.15s;
  margin-bottom: 8px;
}
.filter-tab:hover {
  background: #ebebef;
  color: #3f4254;
  border-color: #d0d0dc;
}
.filter-tab.active {
  background: #fff;
  color: #181c32;
  font-weight: 600;
  border-color: #7dba8f;
  box-shadow: 0 1px 4px rgba(125, 186, 143, 0.15);
}
.filter-count {
  background: #ebebef;
  color: #6c757d;
  border-radius: 10px;
  padding: 1px 7px;
  font-size: 0.75rem;
}
.filter-tab.active .filter-count {
  background: #e2e2ec;
  color: #3f4254;
}
.dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  display: inline-block;
  flex-shrink: 0;
}
.dot-danger  { background: #dc3545; }
.dot-warning { background: #ffc107; }
.dot-info    { background: #0dcaf0; }
</style>
